import type { TradeConfirmationBackToBackFields } from 'state/uiPanelState/tradeConfirmation/tradeConfirm.model';

import * as actionTypes from './tradeConfirm.actionTypes';
import type { BackToBackType } from './tradeConfirm.model';

export type TradeConfirmationActions =
  | ConfirmedIsTrading
  | ConfirmedTermsheetDisclaimer
  | ConfirmedKidDocumentation
  | ConfirmedFrenchPublicOffering
  | TradeConfirmationReset
  | TradeConfirmationInitBackToBack
  | TradeConfirmationSetBackToBackFieldValue
  | TradeConfirmationSetBackedNotionalUnit;

export function confirmedIsTrading(quoteId: string) {
  return {
    type: actionTypes.UI_CONFIRMED_IS_TRADING,
    quoteId,
  };
}

type ConfirmedIsTrading = ReturnType<typeof confirmedIsTrading>;

export function tradeConfirmationReset(quoteId: string) {
  return {
    type: actionTypes.TRADE_CONFIRMATION_RESET,
    quoteId,
  };
}

type TradeConfirmationReset = ReturnType<typeof tradeConfirmationReset>;

export function confirmedTermsheetDisclaimer(quoteId: string, checked: boolean) {
  return {
    type: actionTypes.UI_CONFIRMED_TERMSHEET_DISCLAIMER,
    quoteId,
    checked,
  };
}

type ConfirmedTermsheetDisclaimer = ReturnType<typeof confirmedTermsheetDisclaimer>;

export function confirmedKidDocumentation(quoteId: string, checked: boolean) {
  return {
    type: actionTypes.UI_CONFIRMED_KID_DOCUMENTATION,
    quoteId,
    checked,
  };
}

type ConfirmedKidDocumentation = ReturnType<typeof confirmedKidDocumentation>;

export function confirmedFrenchPublicOffering(quoteId: string, checked: boolean) {
  return {
    type: actionTypes.UI_CONFIRMED_FRENCH_PUBLIC_OFFERING,
    quoteId,
    checked,
  };
}

type ConfirmedFrenchPublicOffering = ReturnType<typeof confirmedFrenchPublicOffering>;

export function tradeConfirmationInitBackToBack(
  quoteId: string,
  isBackToBack: boolean,
  fileCode: string | undefined,
  noteNominal: number | undefined,
  isDeltaAdjusted: boolean | undefined,
  backToBackType: BackToBackType | undefined,
  isDelayedBackToBack?: boolean,
  backedNotional?: number,
) {
  return {
    type: actionTypes.TRADE_CONFIRMATION_INIT_BACK_TO_BACK,
    quoteId,
    isBackToBack,
    fileCode,
    noteNominal,
    isDeltaAdjusted,
    backToBackType,
    isDelayedBackToBack,
    backedNotional,
  };
}
type TradeConfirmationInitBackToBack = ReturnType<typeof tradeConfirmationInitBackToBack>;

export function tradeConfirmationSetBackToBackFieldValue<F extends keyof TradeConfirmationBackToBackFields>(
  quoteId: string,
  field: F,
  value: TradeConfirmationBackToBackFields[F],
) {
  return {
    type: actionTypes.TRADE_CONFIRMATION_SET_BACK_TO_BACK_FIELD_VALUE,
    quoteId,
    field,
    value,
  };
}
type TradeConfirmationSetBackToBackFieldValue = ReturnType<typeof tradeConfirmationSetBackToBackFieldValue>;

export function tradeConfirmationSetBackedNotionalUnit(quoteId: string, unit: string) {
  return {
    type: actionTypes.TRADE_CONFIRMATION_SET_BACKED_NOTIONAL_UNIT,
    quoteId,
    unit,
  };
}
type TradeConfirmationSetBackedNotionalUnit = ReturnType<typeof tradeConfirmationSetBackedNotionalUnit>;
